export const messages = [
  {
    from: "amit",
    to: "Jaky12",
    messages: [
      {
        message: "Hello",
        from: "amit",
      },
      {
        message: "Hi",
        from: "Jaky12",
      },
      {
        message: "How are you",
        from: "amit",
      },
      {
        message: "I am fine",
        from: "Jaky12",
      },
    ],
  },
  {
    from: "amit",
    to: "ahmed",
    messages: [
      {
        message: "Hi",
        from: "amit",
      },
      {
        message: "Hello",
        from: "ahmed",
      },
      {
        message: "How are you?",
        from: "ahmed",
      },
      {
        message: "I am good",
        from: "amit",
      },
    ],
  },
];
